import {createSelector} from "@reduxjs/toolkit";

import ExerciseType from "../exercises/ExerciseType";
import {keyProvider} from "../keyProvider";
import selectAllChapterExerciseIds from "./selectAllChapterExerciseIds";
import selectChapter from "./selectChapter";
import type {RootState} from "../store";

const selectChapterContentStats = createSelector(
	selectAllChapterExerciseIds,
	(state: RootState, key: string) => selectChapter(state, key)?.id ?? 0,
	(state: RootState) => state.chapterExercises.byKey,
	(state: RootState) => state.exercises.byKey,
	(
		exerciseIds,
		chapterId,
		chapterExercises,
		exercises
	): [nonTheoryExercisesCount: number, totalMaxScore: number] => {
		if (chapterId === 0) {
			return [0, 0];
		}

		let exerciseCount = 0;
		let totalMaxScore = 0;

		exerciseIds.forEach((id) => {
			const chEx = chapterExercises[keyProvider.chapterExercise(chapterId, id)];
			if (!chEx) {
				return;
			}

			if (exercises[chEx.exercise]?.type !== ExerciseType.Theory) {
				exerciseCount += 1;
				totalMaxScore += chEx.maxScore ?? 0;
			}
		});

		return [exerciseCount, totalMaxScore];
	}
);

export default selectChapterContentStats;
